import { ActionType } from '../containers/contracts/common-component/ConfirmContractActionModal';
import { ApiResponseType } from './api';
import { GridSortEnum } from './grid';

export enum TabsName {
    CREATED,
    PENDING,
    ACCEPTED,
    RETRACTED,
    DECLINED,
    ONBOARDED,
    GHOSTED,
}

export enum TabsNameAsString {
    CREATED = 'created',
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    RETRACTED = 'retracted',
    DECLINED = 'declined',
    ONBOARDED = 'onboarded',
    GHOSTED = 'ghosted',
    OFFBOARDING_REVIEWS = 'offboardingReviews',
    ONBOARDING_REVIEWS = 'onboardingReviews',
    TOTAL_REVIEWS_PENDING = 'totalReviewsPending',
    TOTAL_REVIEWS_SUBMITTED = 'totalReviewsSubmitted',
}

export const enum TableField {
    PARTNER_NAME = 'partnerName',
    RELEASED_BY = 'releasedBy',
    RELEASED_DATE_STRING = 'releasedDateString',
    RELEASED_DATE = 'releasedDate',
    ACTIONS = 'actions',
    ACCEPTED_DATE_STRING = 'acceptedDateString',
    ACCEPTED_DATE = 'acceptedDate',
    RELEASED_BY_PARTNER_NAME = 'releasedByPartnerName',
    DECLINED_DATE_STRING = 'declinedDateString',
    DECLINED_DATE = 'declinedDate',
    RETRACTED_DATE_STRING = 'retractedDateString',
    RETRACTED_DATE = 'retractedDate',
    CREATED_DATE_STRING = 'createdDateString',
    CREATED_DATE = 'createdDate',
    RATING = 'rating',
    REVIEW_TEXT = 'reviewText',
    REVIEWD_BY = 'reviewedBy',
    REVIEW_TYPE = 'reviewType',
    CANDIDATE = 'candidateName',
}

export enum TabName {
    RELEASED_CONTRACTS,
    RECEIVED_CONTRACTS,
    SUBMITTED_REVIEWS,
}

export type ActionIconsProps = {
    activeTab: TabsName;
    rowData: any;
    tabName: TabName;
    refreshCounts?: () => void;
    refreshTable?: () => void;
    setLoadingAccept?: (key: boolean) => void;
    showModal?: boolean;
    showReviewModal?: boolean;
    setShowRetractContractModal?: (key: boolean) => void;
    setShowModal?: (key: boolean) => void;
    showRetractContractModal?: boolean;
    retractReason?: string;
    clearRetractReason?: () => void;
    showDeclineContractModal?: boolean;
    setShowDeclineContractModal?: (key: boolean) => void;
    declineReason?: string;
    clearDeclineReason?: () => void;
    setReviewData?: (key: any) => void;
    setShowReviewModal?: (key: boolean) => void;
    setDocumentType?: (key: DocumentViewType) => void;
    setCurrentPageName?: (key: ContractPage) => void;
    setStep?: (key: number) => void;
    setActivePage?: (key: ReleaseTab) => void;
    setRetractReason?: (key: string) => void;
    setDeclineReason?: (key: string) => void;
    resetAllState?: () => void;
    showSuccessPopUp?: boolean;
    setShowSuccessPopUp?: (key: boolean) => void;
    successPopUpType?: ActionType | null;
    setSuccessPopUpType?: (key: ActionType | null) => void;
    isCandidate?: boolean;
};

export interface ReviewRequestType {
    stars: number;
    reviewText: string;
    contractComplianceState: ContractComplianceStateEnum | null;
    IsReviewsTermsChecked: boolean;
    contractViolationReason?: string;
}

export enum ContractComplianceStateEnum {
    ContractCompliance = 0,
    ContractViolation = 1,
}

export enum ReleaseTab {
    SEARCH_PARTNER = 'search-partner',
    ADD_DETAILS = 'add-details',
    RELEASE_CONTRACT = 'release-contract',
}

export enum DocumentViewType {
    ACCEPT_DOCUMENT,
    DECLINE_DOCUMENT,
    RETRACT_REASON,
    VIEW_OFFER,
}

export enum ContractPage {
    RELEASED,
    RELEASING,
}

export interface Country {
    name: string;
    code: string;
}

export type UpdateContractStatusType = {
    serviceAgreementId: string;
    serviceStatus: TabsName;
    declinedRetractedReasons: string;
    senderEmail: string;
    receiverEmail: string;
};

export interface Representative {
    name: string;
    code: string;
}

export interface Customer {
    id: number;
    name: string;
    country: Country;
    company: string;
    date: string;
    status: string;
    verified: boolean;
    activity: number;
    representative: Representative;
    balance: number;
}

export type ContractRequestType = {
    reviewText: string;
    stars: number;
    contractComplianceState: ContractComplianceStateEnum;
    reviewType: number;
    partnerReviewId?: string;
};

export enum ReviewerEntityType {
    SENDER,
    RECEIVER,
}

export type CreateReviewRequestType = ContractRequestType & {
    serviceAgreementId: string;
    reviewedOnCompanyId: string;
    reviewerEntityType: ReviewerEntityType;
};

export type CountsResponse = {
    [key in TabsName]?: number;
};

export type TableDataResponse = {
    items: any[];
    totalRecords: number;
};

export type LazyTableState = {
    first: number;
    rows: number;
    page: number;
    sortField?: string; // better to allow undefined initially
    sortOrder?: 1 | -1 | null;
    filters: Record<string, any>;
};

export type ContractListRquestType = {
    serviceStatus?: TabsName;
    companyId?: string;
    start: number;
    limit: number;
    sortField: string;
    sortOrder: GridSortEnum;
    startDate?: Date;
    endDate?: Date;
};

export type ReceivedDataType = {
    releasedByPartnerId: string;
    releasedByPartnerName: string;
    releasedDateString: string;
    releasedDate: string;
    recievingCompanyAverageRating: number;
    recievingCompanyContractComplianceCount: number;
    recievingCompanyContractViolationCount: number;
    partnerReviews: [
        {
            contractComplianceState: number;
            id: string;
            isReviewEditable: boolean;
            modifiedDate: string;
            rating: { value: number };
            reviewText: string;
            reviewType: number;
            reportStatus: number;
        }
    ];
    serviceStatus: TabsName;
    acceptedDateString: string | null;
    acceptedDate: string | null;
    originalServiceAgreementId?: string;
    originalServiceDocumentId: string;
    signedServiceDocumentId: string | null;
    declinedDate: string | null;
    declinedDateString: string | null;
    partnerId: string;
    serviceAgreementId: string;
    partnerAvatarUrl: string;
    partnerName: string;
    senderEmail: string;
    declinedRetractedReasons: string;
    receiverEmail: string;
    recieverAckEmail: string;
    releasedBy: string | null;
    retractedDate: string | null;
    retractedDateString: string | null;
    tabName?: TabName;
    isRevise?: boolean;
};

export type ContractListResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        items: ReceivedDataType[];
        hasMore: boolean;
        count: number;
    };
};

export type AcceptContractRequestType = {
    contractId: string;
};

export type DeclineContractRequestType = {
    contractId: string;
};

export type ContractDigioResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        senderIdentifier: string;
        digioId: string;
        agreementId: string;
    };
};

export type ContractExternalSignatureAccessTokenResponseType = Omit<ApiResponseType, 'resultObject'> & {
    resultObject: {
        entityId: string;
    };
};

export interface GenericOption<T> {
    label: string;
    value: T;
}

export interface GenericSelectProps<T> {
    name: string;
    options: GenericOption<T>[];
    value?: T;
    placeholder?: string;
    onChange?: (value: T) => void;
    className?: string;
}
